var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.change}})])}
var staticRenderFns = []

export { render, staticRenderFns }